import React from 'react';
import TablaEstadoCuentaMinas from '../components/minas/tablaEstadoCuenta';

function estadoCuentaMinas() {
  return (
      <div className='col-12 d-flex justify-content-center row p-0 m-0'>
        <TablaEstadoCuentaMinas />
      </div>
  );
}

export default estadoCuentaMinas;




// WEBPACK FOOTER //
// ./src/pages/estadocuentamina.js